import { unitDecisions } from 'module/AfterCopyright/AfterCopyrightContentControl';

import { Link, useParams } from 'react-router-dom';

import AcceptDecisions from './AcceptDecisions';
import RevertDecision from './RevertDecision';
import ReviewDecision from './ReviewDecision';
import RejectDecision from './RejectDecision';
import RedactionDecisionComponent from './RedactionDecision';
import SendToSupervisorComponent from './SendToSupervisor';

function AfterCopyrightGiveDescision() {
  const { status, offerID } = useParams();

  const handleRenderRoute = (status) => {
    switch (status) {
      case unitDecisions.accept:
        return <AcceptDecisions />;
      case unitDecisions.revert:
        return <RevertDecision />;
      case unitDecisions.review:
        return <ReviewDecision />;
      case unitDecisions.reject:
        return <RejectDecision />;
      case unitDecisions.redaction:
        return <RedactionDecisionComponent />;
      case unitDecisions.sendToSupervisor:
        return <SendToSupervisorComponent />;
      default:
        <></>;
    }
  };

  return (
    <div id="scrollToTop">
      <Link
        className="ant-btn"
        to={`/madde-detay/${offerID}`}
      >
        Geri
      </Link>
      {handleRenderRoute(Number(status))}
    </div>
  );
}
export default AfterCopyrightGiveDescision;
